import { useState, useEffect } from 'react';

import { Breakpoints } from '@/styles/breakpoints';

/**
 * Hook to detect if the viewport is mobile (<768px)
 * Uses matchMedia for efficient resize handling
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < Breakpoints.md;
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${Breakpoints.md - 1}px)`);

    const handleChange = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches);
    };

    // Set initial value
    setIsMobile(mediaQuery.matches);

    // Listen for changes
    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return isMobile;
}
